
import { Vue, prop } from "vue-class-component";

class Props {
  totalStt = prop<number>({ default: 0 });
  totalPieces = prop<number>({ default: 0 });
  totalWeight = prop<string>({ default: "0" });
}

export default class SummaryInfo extends Vue.with(Props) {}
